<template>
    <div>
        <p v-if="getChangedStore1 && (ltype=='1')">{{readFromStore()}}</p>
        <p v-if="getChangedStore2 && (ltype=='2')">{{readFromStore()}}</p>
        <p v-if="getRefresh1 && (ltype=='1')">{{refreshData()}}</p>
        <p v-if="getRefresh2 && (ltype=='2')">{{refreshData()}}</p>

        <p v-if="getSaveBeforeDelete1 || getSaveBeforeDelete2">{{saveBeforeOperation()}}</p>

        <p v-if="getAddElement && !getRefresh1 && !getRefresh2">{{addAnswer()}}</p>
        <p v-if="getDeleteElement > 0 && getCanDelete1 && getCanDelete2">{{deleteAnswer()}}</p>
        
        <div>
            <v-toolbar dense @click="$store.commit('changeCollapse',0)">
            <v-app-bar-nav-icon></v-app-bar-nav-icon>
                    <v-toolbar-title>Assignment ({{mycontent.content.length}} chars)</v-toolbar-title>
            </v-toolbar>
            <div v-if="getCollapses.a">
                <v-flex xs12 >
                    <quill-editor v-model='mycontent.content' :options="getEditorOption()">
                    </quill-editor>
                </v-flex>
                <v-flex xs12 justify-end>
                    <v-btn @click="showHtmlC">Show HTML</v-btn>
                    <v-btn v-if="showedHtmlC" @click="updateC">Update</v-btn>
                </v-flex>
                <v-textarea v-if="showedHtmlC" v-model=HtmlContent>
                </v-textarea>
            </div>
        </div>

        <div>
            <v-toolbar dense @click="$store.commit('changeCollapse',1)">
            <v-app-bar-nav-icon></v-app-bar-nav-icon>
                    <v-toolbar-title>Help ({{mycontent.help.length}} chars)</v-toolbar-title>
            </v-toolbar>
            <div v-if="getCollapses.b">
                <v-flex xs12>
                    <quill-editor v-model='mycontent.help' :options="getEditorOption()">
                        
                    </quill-editor>
                </v-flex>
                <v-flex xs12 justify-end>
                    <v-btn @click="showHtmlH">Show HTML</v-btn>
                    <v-btn v-if="showedHtmlH" @click="updateH">Update</v-btn>
                </v-flex>
                <v-textarea v-if="showedHtmlH" v-model=HtmlHelp>
                </v-textarea>
            </div>
        </div>

        <div>
            <v-toolbar dense @click="$store.commit('changeCollapse',2)">
            <v-app-bar-nav-icon></v-app-bar-nav-icon>
                    <v-toolbar-title>Answers ({{mycontent.answer_list.length}} answer(s))</v-toolbar-title>
            </v-toolbar>            
            <div v-if="getCollapses.c">
                <v-flex xs12>
                    <v-card flat style = "margin-top: 5px" outlined v-for="(item, index) in mycontent.answer_list" :key="index">
                        <v-layout row wrap>
                            <v-flex xs2>
                                <v-overflow-btn
                                    v-if="ltype=='1'"
                                    style = "margin-top: 0px"
                                    :items="getRatingItems"
                                    label="Rating"
                                    editable                            
                                    v-model="ratings[index]"
                                    item-value="text"
                                ></v-overflow-btn>
                            </v-flex>
                            
                            <v-flex xs10>
                                <v-text-field
                                    v-model="mycontent.answer_list[index].answer"
                                    label="Answer"
                                    ></v-text-field>
                            </v-flex>
                            <v-flex xs2 > 
                                <v-layout justify-center>
                                {{index}} <v-icon v-if="ltype == '1' && index > 0" @click="deleteAnswerEvent(index)">mdi-minus-circle-outline</v-icon>     
                                </v-layout>
                            </v-flex>
                            <v-flex xs10>
                                <v-text-field
                                    v-model="mycontent.answer_list[index].feedback"
                                    label="Feedback"
                                    ></v-text-field>
                            </v-flex>          
                        </v-layout>  
                    </v-card>
                </v-flex>
                <v-flex xs12>
                    <v-layout justify-center>
                        <p></p>
                        <v-icon v-if="ltype == '1'" @click="addAnswer">mdi-plus-circle-outline</v-icon>            
                    </v-layout>
                </v-flex>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// import hljs from 'highlight.js'
import { quillEditor } from 'vue-quill-editor'
// import 'highlight.js/styles/googlecode.css'

export default {
    data() {
        return {
                showedHtmlC : false,
                showedHtmlH : false,
                mycontent:  {
                    content: 'loading...',
                    help: 'loading...',
                    answer_list : [{
                        answer : 'loading...',
                        feedback: 'loading...'
                    }]
                },
                HtmlContent: '',
                HtmlHelp: '',
                ratings : [100],
                show : {
                    question: true,
                    feedback: true,
                    answers: true
                }
              }
    },
    props: ['ltype'],
    computed: 
            mapGetters([
                            'getLanguagePrimary',   
                            'getLanguageSecondary',
                            'getLanguagePrimaryTmp',   
                            'getLanguageSecondaryTmp',
                            'getRefresh1',
                            'getRefresh2',
                            'getCanDelete1',
                            'getCanDelete2',
                            'getSaveBeforeDelete1',
                            'getSaveBeforeDelete2',
                            'getChangedStore1',
                            'getChangedStore2',
                            'getAddElement',
                            'getDeleteElement',
                            'getContent24',
                            'getRatingItems',
                            'getRatings',
                            'getCollapses'
                        ])
    ,
    components: {
        quillEditor
    },
    methods: {
        showHtmlC() {
            this.showedHtmlC = !this.showedHtmlC
            this.HtmlContent = this.mycontent.content
        },
        showHtmlH() {
            this.showedHtmlH = !this.showedHtmlH
            this.HtmlHelp = this.mycontent.help
        },
        updateC() {
            this.mycontent.content = this.HtmlContent
        },
        updateH() {
            this.mycontent.help = this.HtmlHelp
        },

        /************************************************************ */
        addAnswerEvent() {
            this.$store.commit('setRefresh1',true) // to save all content
            this.$store.commit('setRefresh2',true)            
            this.$store.commit('setAddElement',true)
        },
        addAnswer() {
            this.$store.commit('setAddElement',false)
            this.$store.commit('addAnswertoList24')
        },
        deleteAnswerEvent(index) {
            this.$store.commit('setCanDelete1',false) 
            this.$store.commit('setCanDelete2',false)     
            this.$store.commit('setSaveBeforeDelete1',true) 
            this.$store.commit('setSaveBeforeDelete2',true)        
            this.$store.commit('setDeleteElement',index)
        },
        deleteAnswer() {
            var index = this.getDeleteElement
            this.$store.commit('setDeleteElement',0)
            this.$store.dispatch('deleteAnswerinList', index)           
        },
        /************************************************************ */
        saveActualContent(mylang) {   
            this.$store.commit('setRatings',this.ratings)

            var data = {
                lang_id : mylang.id,
                content: this.mycontent
            }
            this.$store.commit('setContent24', data)            
        },
        /************************************************************/
        saveBeforeOperation() {
            if (this.ltype =='1') {
                this.$store.commit('setRefresh1',false)
                if (this.getLanguagePrimary) 
                    this.saveActualContent(this.getLanguagePrimary)
                this.$store.commit('setSaveBeforeDelete1',false) 
                this.$store.commit('setCanDelete1',true)
            } else {
                this.$store.commit('setRefresh2',false)
                if (this.getLanguageSecondary)
                    this.saveActualContent(this.getLanguageSecondary)
                this.$store.commit('setSaveBeforeDelete2',false) 
                this.$store.commit('setCanDelete2',true)
            }            
        },
        /************************************************************/
        refreshData() {
            if (this.ltype =='1') {
                this.$store.commit('setRefresh1',false)
                if (this.getLanguagePrimaryTmp) 
                    this.saveActualContent(this.getLanguagePrimaryTmp)
                this.$store.commit('setChangedStore1',true)
            } else {
                this.$store.commit('setRefresh2',false)
                if (this.getLanguageSecondaryTmp)
                    this.saveActualContent(this.getLanguageSecondaryTmp)
                this.$store.commit('setChangedStore2',true)            
            }            
        },
        getContent24fromStore(lang_id) {
            return this.getContent24(lang_id)
        },

        readFromStore() {
            this.ratings = this.getRatings
            if (this.ltype == 1) {
                this.$store.commit('setChangedStore1',false)
                let con = this.getContent24fromStore(this.getLanguagePrimary.id)
                this.mycontent = con
            }
            if (this.ltype == 2) {                
                this.$store.commit('setChangedStore2',false)
                let con = this.getContent24fromStore(this.getLanguageSecondary.id)
                this.mycontent = con
            }
        },
        getEditorOption() {
          return {
                modules: {
                    'toolbar': [
                    [{ 'header': '1' }, { 'header': '2' }],
                    [ 'bold', 'italic', 'underline', 'strike' ],
                    ['code-block','blockquote',  { 'color': [] }, { 'background': [] }],
                    [{ 'script': 'super' }, { 'script': 'sub' }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet'}, { 'indent': '-1' }, { 'indent': '+1' }],
                    [{ 'align': [] }],
                    [ 'link', 'image', 'formula' ],
                    [ 'clean' ]
                    ],
      /*              syntax: {
                    highlight: text => hljs.highlightAuto(text).value
                    },
        */            imageDrop: true,
                    imageResize: true
                },
                theme: 'snow'
            }
        }
    } 

}
</script>


<style>

</style>


